"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbooksDisplayGrid = exports.getRowDataForWorkbook = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
var projectContainerType = 'project';
function getRowDataForWorkbook(workbook) {
    return {
        id: workbook.id,
        name: workbook.name,
        vizportalUrlId: workbook.vizportalUrlId,
        owner: workbook.owner,
        sheetCount: workbook.sheetsConnection ? workbook.sheetsConnection.totalCount : null,
        containerName: workbook.containerName,
        containerType: workbook.containerType,
        projectVizportalUrlId: workbook.projectVizportalUrlId,
    };
}
exports.getRowDataForWorkbook = getRowDataForWorkbook;
function columns() {
    var cols = [
        function (sortParams) { return ({
            name: 'name',
            dataKey: queries_1.WorkbookOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter)(shouldBeObfuscated, function (_a) {
                var name = _a.name;
                return name;
            }, function (urls, _a) {
                var vizportalUrlId = _a.vizportalUrlId;
                return urls.workbookLineagePath(vizportalUrlId);
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'sheets',
            dataKey: queries_1.WorkbookOrderField.SHEETS_COUNT,
            headerText: Localize_1.Messages.GridHeaderSheets(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(function (_a) {
                var sheetCount = _a.sheetCount;
                return sheetCount;
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'location',
            dataKey: queries_1.WorkbookOrderField.PROJECT_NAME,
            headerText: Localize_1.Messages.GridHeaderLocation(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, LinkCellFormatter_1.createLinkOrTextCellFormatter)(function (_a) {
                var containerType = _a.containerType, containerName = _a.containerName;
                return containerType === projectContainerType ? containerName : Localize_1.Messages.PersonalSpaceName();
            }, function (urls, _a) {
                var projectVizportalUrlId = _a.projectVizportalUrlId, containerType = _a.containerType;
                return (projectVizportalUrlId && containerType === projectContainerType ? urls.projectPath(projectVizportalUrlId) : null);
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'owner',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderOwner(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, UserNameCell_1.createUserNameLinkCellFormatter)(function (_a) {
                var owner = _a.owner;
                return owner;
            }),
            resizable: true,
            sortable: false,
        }); },
    ];
    return cols.filter(Boolean);
}
function WorkbooksDisplayGrid(props) {
    var cols = columns().map(function (columnFactory) { return columnFactory(props); });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.WorkbooksDisplayGrid = WorkbooksDisplayGrid;
//# sourceMappingURL=WorkbooksDisplayGrid.js.map